import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";

export const CalculatorCard = ({ page }) => (
  <Link
    to={`/${page.slug}`}
    data-testid={`calculator-card-${page.slug}`}
    className="group flex flex-col border border-ink-line bg-ink-surface transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-accent hover:shadow-[0_0_28px_rgba(244,123,32,0.18)]"
  >
    <div className="h-44 overflow-hidden border-b border-ink-line">
      <img
        src={page.heroImage}
        alt={page.heroImageAlt}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent">{page.projectType}</p>
      <h3 className="mt-3 font-display text-lg uppercase leading-tight text-ink-text">{page.calculator.name}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-muted">{page.cardBlurb}</p>
      <span className="mt-6 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-ink-text transition-colors duration-200 group-hover:text-accent">
        Open page
        <ArrowRight className="h-4 w-4 text-accent transition-transform duration-300 group-hover:translate-x-1" />
      </span>
    </div>
  </Link>
);

export const RelatedCalculators = ({ items }) => (
  <section className="border-y border-ink-line bg-ink-surface py-24 sm:py-32" data-testid="related-calculators-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-accent">Related Calculators</p>
        <h2 className="mt-4 font-display text-3xl uppercase leading-none tracking-tight text-ink-text sm:text-4xl lg:text-5xl">
          Keep the takeoff going
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((page, i) => (
          <Reveal key={page.slug} delay={i * 0.1}>
            <CalculatorCard page={page} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
